import { useState } from "react";
import { FullscreenTakeover } from "@jsq/ds/core";
import { ComplianceObjectType } from "~/graphql/supergraphEnums";
import { ExtractedDataPreviewPanel } from "~/pages/Compliance/documents/ExtractedDataPreviewPanel";
import { ExitWarningModal } from "../../../../Common/ExitWarningModal";
import { useInvestorWizard } from "../../context";
import { WizardFooterBar } from "../../WizardFooterBar";
import { EntityProfileForm } from "../EntityProfileForm";
import { IndividualProfileForm } from "../IndividualProfileForm";
import type { ManualCategory } from "../types";

interface Props {
  documentId: number;
  category: ManualCategory;
  onBack: () => void;
  onViewExistingProfile?: (taxId: string) => void;
}

export const ProfileExtractionPreview = ({
  documentId,
  category,
  onBack,
  onViewExistingProfile,
}: Props) => {
  const { footerContent } = useInvestorWizard();
  const [showExitWarning, setShowExitWarning] = useState(false);

  const requestExit = () => setShowExitWarning(true);

  return (
    <FullscreenTakeover>
      <FullscreenTakeover.Header title="Create profile from document" onExit={requestExit} />
      <ExtractedDataPreviewPanel documentId={documentId}>
        {(extractedData) =>
          category === ComplianceObjectType.Individual ? (
            <IndividualProfileForm
              onBack={requestExit}
              extractedData={extractedData}
              documentId={documentId}
              onViewExistingProfile={onViewExistingProfile}
            />
          ) : (
            <EntityProfileForm
              onBack={requestExit}
              extractedData={extractedData}
              documentId={documentId}
              onViewExistingProfile={onViewExistingProfile}
            />
          )
        }
      </ExtractedDataPreviewPanel>
      {footerContent && (
        <FullscreenTakeover.Footer>
          <WizardFooterBar fullWidth>{footerContent}</WizardFooterBar>
        </FullscreenTakeover.Footer>
      )}
      <ExitWarningModal
        show={showExitWarning}
        onCancel={() => setShowExitWarning(false)}
        onConfirm={onBack}
      />
    </FullscreenTakeover>
  );
};
